<template>
	<Row>
		<Column>
			<Box>
				<h1>Log in</h1>

				<Form
					action="/api/sessions/log_in"
					name="Log in"
					@submit=" onSubmit "
				>
					<Row>
						<Column class="md">
							<Input
								label="Username"
								name="username"
								placeholder="Username"
							/>
							<Input
								label="Password"
								name="password"
								type="password"
								placeholder="Password"
							/>
							<Checkbox
								label="Remember me"
								name="remember"
							/>
						</Column>
					</Row>
				</Form>
			</Box>
		</Column>
	</Row>
</template>

<script lang="ts" setup>
definePageMeta ( {
	middleware: 'no-auth'
} )

const notifications = useNotificationsStore ()

let lastNotification : string

const onSubmit = ( async ( res: Response ) =>
{
	if ( !res.ok )
	{
		if ( lastNotification )
		{
			notifications.removeNotification ( lastNotification )
		}

		lastNotification = notifications.addNotification ( 'Log in failed', ( await res.json () ).error, 'error' )
		return
	}

	const me = useState<User> ( 'me' )
	me.value = await res.json ()
	navigateTo ( '/me' )

	notifications.addNotification ( 'Log in successful', `Welcome back ${ me.value.username }!`, 'success' )
} )
</script>
